import { render } from "./CallToActionFeedbackNew.vue?vue&type=template&id=d53ece5a&scoped=true"
import script from "./CallToActionFeedbackNew.vue?vue&type=script&lang=js"
export * from "./CallToActionFeedbackNew.vue?vue&type=script&lang=js"

import "./CallToActionFeedbackNew.vue?vue&type=style&index=0&id=d53ece5a&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53ece5a"]])

export default __exports__